import { Tag } from 'antd';

import type {
  TWorkJourneyManagementActionType,
  TWorkJourneyManagementAttentionReason,
} from '@src/models/interfaces/workJourneyManagement.interface';
import IntlMessages from '@src/util/IntlMessages';

import styles from './styles.module.less';

interface WorkJourneyAttentionStatusBadgeProps {
  reason: TWorkJourneyManagementAttentionReason;
}

const REASON_COLORS: Record<TWorkJourneyManagementAttentionReason, string> = {
  below_minimum: 'error',
  rejected_change: 'purple',
  staffing_shortage: 'error',
};

/** Outline-only: same error border/text as below_minimum, transparent fill. */
const OUTLINED_REASONS: TWorkJourneyManagementAttentionReason[] = ['staffing_shortage'];

export const WorkJourneyAttentionStatusBadge = ({ reason }: WorkJourneyAttentionStatusBadgeProps) => {
  const isOutlined = OUTLINED_REASONS.includes(reason);

  return (
    <Tag
      color={REASON_COLORS[reason]}
      className={`gx-mb-0 gx-mr-0 ${styles.badge} ${isOutlined ? styles.outlined : ''}`}
    >
      <IntlMessages id={`workJourney.management.reason.${reason}`} />
    </Tag>
  );
};

export const getActionLabelId = (actionType: TWorkJourneyManagementActionType): string =>
  `workJourney.management.action.${actionType}`;

export const isPrimaryAction = (actionType: TWorkJourneyManagementActionType): boolean =>
  actionType !== 'hiring';
